import React from 'react';
import {
  checkCurrentWhatsappStatus,
  setCurrentWhatsappStatus,
} from '../actionCreators/gupshupWhatsapp';
import { setToastMessage } from '../actionCreators/common';
import { connect } from 'react-redux';
import './GupshupWhatsapp.scss';

const toggleStylePages = ['Success', 'OrderList'];

class GupshupWhatsapp extends React.PureComponent {
  constructor(props) {
    super(props);
    const { page, checkCurrentWhatsappStatus, isOptWhatsApp, WHATSAPP_OPTIN } = props;
    const toggleStyle = toggleStylePages.includes(page);
    if (toggleStyle) checkCurrentWhatsappStatus();
    this.state = {
      isUserOptInForWhatsapp: toggleStyle ? isOptWhatsApp : WHATSAPP_OPTIN.toggle === 'ON',
    };
    this.setWhatsappOptIn = this.setWhatsappOptIn.bind(this);
    this.newStyle = !!this.props.newStyle;
  }

  componentDidUpdate(prevProps) {
    const { setToastMessage, isOptWhatsApp, isUserAction, error, dataLocale } = this.props;
    const {
      YOU_WILL_START_RECEIVING_UPDATE,
      YOU_WILL_NOT_RECEIVE_UPDATES,
      UNABLE_TO_SERVE_YOUR_REQUEST,
    } = dataLocale;
    if (prevProps.isOptWhatsApp !== isOptWhatsApp && isUserAction) {
      ('#if CLIENT_TYPE === "mobile"'); // eslint-disable-line
      setToastMessage({
        message: (isOptWhatsApp && YOU_WILL_START_RECEIVING_UPDATE) || YOU_WILL_NOT_RECEIVE_UPDATES,
        timeout: 5000,
      });
      ('#endif'); // eslint-disable-line
    }
    if (prevProps.error !== error && error && isUserAction) {
      ('#if CLIENT_TYPE === "mobile"'); // eslint-disable-line
      setToastMessage({ warning: true, message: UNABLE_TO_SERVE_YOUR_REQUEST, timeout: 3000 });
      ('#endif'); // eslint-disable-line
    }
  }

  setWhatsappOptIn() {
    const { isUserOptInForWhatsapp } = this.state;
    const { isOptWhatsApp, setCurrentWhatsappStatus, checkBoxStatus, page } = this.props;
    const toggleStyle = toggleStylePages.includes(page);
    if (toggleStyle) {
      setCurrentWhatsappStatus(!isOptWhatsApp);
    } else {
      this.setState({ isUserOptInForWhatsapp: !isUserOptInForWhatsapp }, () => {
        checkBoxStatus(this.state.isUserOptInForWhatsapp);
      });
    }
  }

  render() {
    const {
      page,
      isOptWhatsApp,
      WHATSAPP_OPTIN,
      dataLocale: { RECEIVE_ORDER_UPDATES_WHATSAPP },
    } = this.props;
    const { isUserOptInForWhatsapp } = this.state;
    const toggleStyle = toggleStylePages.includes(page);
    return (
      <React.Fragment>
        <div
          className="whatsappBlock text-center margin-t20"
          data-testid="whatsappContainer"
          style={this.newStyle ? { margin: 0 } : {}}
        >
          {toggleStyle ? (
            <label
              className="toggle-style display-flex align-items-center justify-content-center"
              htmlFor="toggleStatus"
              onClick={this.setWhatsappOptIn}
            >
              <div className="inline-block whatsapp-logo">
                <img
                  alt="whatsapp"
                  src="https://static.lenskart.com/media/desktop/img/25-July-19/whatsapp.png"
                />
              </div>
              <span className={`${!this.newStyle ? 'fw500' : 'new-style-font'}`}>
                {WHATSAPP_OPTIN.message || RECEIVE_ORDER_UPDATES_WHATSAPP}
              </span>
              <div className="switch inline-block cursor-pointer">
                <div
                  className={`${isOptWhatsApp ? 'active' : ''} block toggleswitch`}
                  data-testid="switch"
                  id="toggleStatus"
                >
                  <span className="block handle"></span>
                </div>
              </div>
            </label>
          ) : (
            <label
              className="login-window-whatsapp display-flex align-items-center justify-content-center margin-b15"
              htmlFor="checkboxStatus"
              style={
                this.newStyle
                  ? {
                      display: 'flex',
                      margin: '0px',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                    }
                  : {}
              }
            >
              <div className="inline-block margin-r5">
                {!this.newStyle ? (
                  <input
                    aria-label="Click to subscribe or unsubscribe for status of your orders"
                    checked={isUserOptInForWhatsapp}
                    id="checkboxStatus"
                    type="checkbox"
                    onChange={this.setWhatsappOptIn}
                  />
                ) : (
                  <label className="auth-modal-checkbox-label">
                    <input
                      checked={isUserOptInForWhatsapp}
                      id="checkboxStatus"
                      type="checkbox"
                      onChange={this.setWhatsappOptIn}
                    />
                    <span className="auth-checkbox-custom">
                      {isUserOptInForWhatsapp && (
                        <img
                          alt="checked"
                          src="https://static1.lenskart.com/media/desktop/img/DesignStudioIcons/CheckBlueSmall.svg"
                        />
                      )}
                    </span>
                  </label>
                )}
                {!this.newStyle && <span className="checkmark"></span>}
              </div>
              <span className={`${!this.newStyle ? 'fw400 padding-l22 pd-l20' : 'new-style-font'}`}>
                {WHATSAPP_OPTIN.message || RECEIVE_ORDER_UPDATES_WHATSAPP}
              </span>
              <div className="inline-block whatsapp-logo-login">
                <img
                  alt="whatsapp"
                  src="https://static.lenskart.com/media/desktop/img/25-July-19/whatsapp.png"
                />
              </div>
            </label>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    isOptWhatsApp: state.gupshupWhatsapp.isOptWhatsApp,
    isUserAction: state.gupshupWhatsapp.isUserAction,
    error: state.gupshupWhatsapp.error,
    dataLocale: state.locale,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    checkCurrentWhatsappStatus: () => dispatch(checkCurrentWhatsappStatus()),
    setCurrentWhatsappStatus: status => dispatch(setCurrentWhatsappStatus(status, true)),
    setToastMessage: data => dispatch(setToastMessage(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GupshupWhatsapp);
